import React from 'react'
import { useFeedbackAPI, SubjectRating } from './api/feedback'
import { Panel, Line } from './fragments/comp/panel'

import Rating from 'components/lib/rating'

export default function FeedbackInfo() {
  const feedbackAPI = useFeedbackAPI()
  if (feedbackAPI.hasFeedback()) {
    const review = feedbackAPI.getReview()
    return (
      <div className="row">
        <div className="col-12">
          <Panel id="feedback" label="Order Feedback" actions={[]}>
            <Line label="Rating">
              <Rating score={feedbackAPI.getSessionAverage()} />
            </Line>
            {feedbackAPI.getQuestionsRatings().map((qr: SubjectRating) => (
              <Line key={qr.id} label={qr.name}>
                <Rating score={qr.score / 5} />
              </Line>
            ))}
            {review && (
              <Line label="Customer Review">
                <div
                  className="panel"
                  style={{
                    fontFamily: 'cursive',
                    fontWeight: 'bold',
                    padding: '5px 0px',
                    backgroundColor: '#eee',
                    border: '1px solid #bbb',
                  }}
                >
                  {review}
                </div>
              </Line>
            )}
          </Panel>
        </div>
      </div>
    )
  }
  return <></>
}
